/** Pixen Intrigue — English overrides for the community feature. Courtly-fae voice. */
export const communityPixEn = {
  // CommunityPage
  'community.page.seoDescription':
    'Join the Pixen Intrigue community: forums, lore theories, GM tools, homebrew, and the Hall of Legends.',
  'community.page.eyebrow': 'The Salon',
  'community.page.intro':
    'Trade secrets, spin theories, share homebrew, and rise toward canon. Every post you make earns favors and standing in the Court.',
  'community.page.loading': 'Gathering the Court…',
  'community.page.recentEmpty': 'The salon is quiet tonight. Start a discussion to break the silence.',
  'community.page.hallBlurb': 'The greatest contributors and the courtiers they forged into canon.',
  'community.page.summoningLegends': 'Summoning legends…',
  'community.page.sampleNotice': 'Showing sample community content while the live forums come online.',

  // ForumCategoryPage
  'community.category.seoDescription': 'Discussions in the {name} forum on Pixen Intrigue.',
  'community.category.sampleNotice': 'Showing sample threads while the live forum comes online.',

  // HallOfLegendsPage
  'community.legends.seoDescription':
    'The greatest contributors to Pixen Intrigue and the courtiers they forged into canon.',
  'community.legends.intro':
    'Here stand the favorites of the Court — the contributors whose words became law, and the courtiers so beloved they were carved into canon.',
  'community.legends.loading': 'Lighting the candles…',
  'community.legends.noContributors': 'No favorites have risen yet. Post, theorize, and create to claim your place.',
  'community.legends.noCharacters': 'No courtiers have been canonized yet. The Court awaits its next favorite.',
  'community.legends.sampleNotice': 'Showing sample legends while the live hall comes online.',

  // PostComposer
  'community.composer.placeholder': 'Add your voice to the salon…',

  // ThreadPage
  'community.threadPage.loading': 'Unsealing the thread…',
  'community.threadPage.seoDescription': 'A discussion in the Pixen Intrigue community forums.',
  'community.threadPage.sampleNotice': 'Showing sample discussion while the live forum comes online.',
}
